import { mutate } from 'swr'
import useSWRImmutable from 'swr/immutable'

import { bookmarkCourse, getAllCourses, getBookmarkedCourses, getCourseById } from '../../api/courses'
import useSWRMutation from 'swr/mutation'

const CACHE_KEYS = {
  BASE: 'courses',
  ALL: 'all',
  BOOKMARKED: 'bookmarked',
} as const

export const useAllCourses = () => {
  return useSWRImmutable([CACHE_KEYS.BASE, CACHE_KEYS.ALL], () => getAllCourses())
}

export const useBookmarkedCourses = () => {
  return useSWRImmutable([CACHE_KEYS.BASE, CACHE_KEYS.BOOKMARKED], () => getBookmarkedCourses())
}

export const useCourseById = (courseId: string) => {
  return useSWRImmutable(courseId ? [CACHE_KEYS.BASE, courseId] : null, () => getCourseById({ id: courseId }))
}

export const useInvalidateCourseCache = async () => {
  await mutate(key => Array.isArray(key) && key[0] === CACHE_KEYS.BASE)
}

export const useMutateBookmarkCourse = (courseId: string) => {
  return useSWRMutation([CACHE_KEYS.BASE, courseId], bookmarkCourse, {
    onSuccess: async () => {
      await useInvalidateCourseCache()
    },
  })
}
